var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loader)?_c('div',{staticClass:"loading"},[(_vm.loader)?_c('i',{staticClass:"fas fa-spinner fa-pulse"}):_vm._e()]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }